import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import isOnCalendarTallyingResponses from 'owa-calendar-forms-common/lib/utils/isOnCalendarTallyingResponses';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';

/**
 * This is based whether the event is on a calendar which can tally responses
 *  @param event : The event
 */
export default (event: CalendarEvent): InfoBarMessageViewState[] =>
    !isOnCalendarTallyingResponses(event) && isEventAMeeting(event)
        ? [InfoBarViewStates.getWarningNoResponseTrackingForMeetingOnSecondaryCalendar()]
        : [];
